module.exports = __webpack_public_path__ + "static/media/img-poster-fg@3x.c9953a18.png";